module.exports = __webpack_public_path__ + "d6f5c46a7d1b5f55e078528893094b2a.png";